/** Ported from legacy Project.js (getContents + skillsBak). */
export const PROJECT_DETAILS = {
  "eco": {
    "description": "Built and maintained a WordPress and WooCommerce implementation, including feature enhancements, bug fixes, and custom plugin development. Improved site layout quality and strengthened SEO readiness.",
    "impact": "Led Shopify → custom WooCommerce platform migration; maintained 2 production plugins and drove measurable organic traffic growth through SEO improvements.",
    "tags": [
      "#wordpress",
      "#woocommerce",
      "#php",
      "#html",
      "#css",
      "#js",
      "#jquery",
      "#pug",
      "#nodejs",
      "#seo",
      "#debug",
      "#enhancement",
      "#sass",
      "#jade",
      "#plugin",
      "#wordpressplugin",
      "#admin",
      "#mobileresponsive",
      "#angularjs"
    ],
    "websiteUrl": "https://www.ecoshiftcorp.com/"
  },
  "sc": {
    "description": "Delivered a full front-end redesign on a .NET (Kentico) platform, converting PSD designs into production-ready HTML, CSS, and JavaScript with responsive behavior across desktop and mobile.",
    "impact": "Shipped production-ready redesign for Star Cinema — ABS-CBN's film arm — reaching millions of monthly visitors across the Philippines.",
    "tags": [
      "#html",
      "#css",
      "#sass",
      "#javascript",
      "#jquery",
      "#pug",
      "#jade",
      "#psdtohtml",
      "#bootstrap",
      "#mobileresponsive"
    ],
    "websiteUrl": "https://starcinema.abs-cbn.com/"
  },
  "kty": {
    "description": "Implemented a complete UI refresh on .NET (Kentico), translating PSD assets into responsive HTML, CSS, and JavaScript for desktop and mobile users.",
    "tags": [
      "#html",
      "#css",
      "#sass",
      "#javascript",
      "#jquery",
      "#pug",
      "#jade",
      "#psdtohtml",
      "#angular",
      "#mobileresponsive"
    ],
    "websiteUrl": "https://thankyou.abs-cbn.com/"
  },
  "push": {
    "description": "Rebuilt the interface on .NET (Kentico) from PSD to responsive HTML, CSS, and JavaScript, with improvements for usability across devices.",
    "tags": [
      "#html",
      "#psdtohtml",
      "#pug",
      "#jade",
      "#nodejs",
      "#debug",
      "#javascript",
      "#jquery",
      "#socialmedia",
      "#seo",
      "#css",
      "#sass",
      "#mobileresponsive"
    ],
    "websiteUrl": "https://push.abs-cbn.com"
  },
  "corp": {
    "description": "Enhanced the corporate website through targeted UI, front-end, and maintenance improvements.",
    "tags": [
      "#html",
      "#css",
      "#sass",
      "#javascript",
      "#jquery",
      "#pug",
      "#jade",
      "#psdtohtml",
      "#mobileresponsive",
      "#enhancement",
      "#debug"
    ],
    "websiteUrl": "https://www.abs-cbn.com/corporate"
  },
  "careers": {
    "description": "Improved the careers website with front-end enhancements, usability refinements, and issue resolution.",
    "tags": [
      "#html",
      "#css",
      "#sass",
      "#javascript",
      "#jquery",
      "#pug",
      "#jade",
      "#psdtohtml",
      "#enhancement",
      "#debug"
    ],
    "websiteUrl": "https://careers.abs-cbn.com/"
  },
  "anc": {
    "description": "Built and delivered an ANC event form experience for a one-week campaign window.",
    "tags": [
      "#html",
      "#css",
      "#sass",
      "#javascript",
      "#jquery",
      "#pug",
      "#jade",
      "#psdtohtml",
      "#enhancement",
      "#debug"
    ]
  },
  "kaiaq": {
    "description": "Developed and prepared the KAIAQ Admin Template for internal platform use.",
    "tags": [
      "#html",
      "#css",
      "#sass",
      "#javascript",
      "#jquery",
      "#pug",
      "#jade",
      "#psdtohtml",
      "#enhancement",
      "#debug",
      "#bootstrap"
    ]
  },
  "asphaltnitro": {
    "description": "Built this one-pager from scratch by converting PSD layouts into responsive HTML, CSS, and JavaScript. Also created a reusable CodeIgniter base to standardize shared components across Gameloft campaign pages.",
    "tags": [
      "#codeigniter",
      "#psdtohtml",
      "#html",
      "#php",
      "#debug",
      "#mobileresponsive",
      "#css",
      "#less",
      "#nodejs"
    ],
    "websiteUrl": "https://www.gameloft.com/en/game/asphalt-nitro-mobile"
  },
  "asphalt8": {
    "description": "Delivered end-to-end front-end implementation from PSD to responsive HTML, CSS, and JavaScript, then integrated a reusable CodeIgniter structure for consistency across related Gameloft one-pager sites.",
    "tags": [
      "#codeigniter",
      "#psdtohtml",
      "#html",
      "#php",
      "#debug",
      "#mobileresponsive",
      "#css",
      "#less",
      "#nodejs"
    ],
    "websiteUrl": "https://www.gameloft.com/asphalt8/"
  },
  "cc": {
    "description": "Maintained and enhanced the support site by resolving cross-layer issues in PHP, HTML, CSS, and JavaScript.",
    "tags": [
      "#codeigniter",
      "#debug",
      "#enhancement",
      "#php"
    ],
    "websiteUrl": "https://support.gameloft.com/"
  },
  "dm": {
    "description": "Implemented the site from PSD to production with responsive HTML, CSS, and JavaScript, and leveraged a shared CodeIgniter foundation for repeatable development across Gameloft microsites.",
    "tags": [
      "#codeigniter",
      "#psdtohtml",
      "#html",
      "#php",
      "#debug",
      "#mobileresponsive",
      "#css",
      "#less",
      "#nodejs"
    ],
    "websiteUrl": "https://minionrush.com/"
  },
  "dh5": {
    "description": "Developed this campaign site from the ground up using PSD-based front-end implementation and responsive design, supported by a reusable CodeIgniter framework for shared components.",
    "tags": [
      "#codeigniter",
      "#psdtohtml",
      "#html",
      "#php",
      "#debug",
      "#mobileresponsive",
      "#css",
      "#less",
      "#nodejs"
    ],
    "websiteUrl": "http://dungeonhunter5.com/"
  },
  "gl-forum": {
    "description": "Improved site stability and functionality through maintenance and bug fixes across PHP, HTML, CSS, and JavaScript.",
    "tags": [
      "#codeigniter",
      "#debug",
      "#enhancement",
      "#php"
    ],
    "websiteUrl": "https://forum.gameloft.com/"
  },
  "gor": {
    "description": "Built and launched the site from PSD assets with responsive HTML, CSS, and JavaScript, while reusing a CodeIgniter base to streamline delivery across similar projects.",
    "tags": [
      "#codeigniter",
      "#psdtohtml",
      "#html",
      "#php",
      "#debug",
      "#mobileresponsive",
      "#css",
      "#less",
      "#nodejs"
    ],
    "websiteUrl": "https://www.gameloft.com/en/game/gods-of-rome"
  },
  "hoc": {
    "description": "Executed full front-end development from PSD to responsive production output and reused a common CodeIgniter architecture for scalable one-pager development.",
    "tags": [
      "#codeigniter",
      "#psdtohtml",
      "#html",
      "#php",
      "#debug",
      "#mobileresponsive",
      "#css",
      "#less",
      "#nodejs"
    ],
    "websiteUrl": "http://www.heroesoforderandchaosgame.com/index.php"
  },
  "sf": {
    "description": "Delivered a complete PSD-to-web implementation with mobile-ready behavior and reusable CodeIgniter patterns to support faster delivery across related game pages.",
    "tags": [
      "#codeigniter",
      "#psdtohtml",
      "#html",
      "#php",
      "#debug",
      "#mobileresponsive",
      "#css",
      "#less",
      "#nodejs"
    ],
    "websiteUrl": "https://www.sniperfury.com/"
  },
  "tbc": {
    "description": "Built this project from scratch from PSD designs and implemented responsive HTML, CSS, and JavaScript, backed by a reusable CodeIgniter setup for maintainable one-pager releases.",
    "tags": [
      "#codeigniter",
      "#psdtohtml",
      "#html",
      "#php",
      "#debug",
      "#mobileresponsive",
      "#css",
      "#less",
      "#nodejs"
    ],
    "websiteUrl": "https://www.gameloft.com/en-gb/game/blacklist"
  },
  "coll8or": {
    "description": "Built a social aggregation experience that unified multiple social media feeds through API integrations.",
    "tags": [
      "#socialmedia",
      "#php",
      "#codeigniter",
      "#debug",
      "#html",
      "#api",
      "#javascript",
      "#jquery",
      "#css",
      "#less"
    ],
    "websiteUrl": "http://coll8or.com/"
  },
  "kinkcakes": {
    "description": "Implemented a branded website experience for a cake-focused business, including front-end presentation and interaction polish.",
    "tags": [
      "#css",
      "#less",
      "#psdtohtml",
      "#javascript",
      "#jquery",
      "#debug"
    ],
    "websiteUrl": "http://kinkcakes.com.ph/"
  },
  "zmr": {
    "description": "Developed a publication-style site for company updates, project highlights, and media content across multiple regions.",
    "tags": [
      "#css",
      "#sass",
      "#psdtohtml",
      "#javascript",
      "#jquery",
      "#debug",
      "#html",
      "#wordpress",
      "#wordpresstheme"
    ],
    "websiteUrl": "http://zenomediarelease.com/"
  },
  "zbceuit": {
    "description": "Designed and developed a company site for an Italy-based construction business with a clean, responsive front-end.",
    "tags": [
      "#css",
      "#sass",
      "#psdtohtml",
      "#javascript",
      "#jquery",
      "#debug",
      "#html",
      "#jade",
      "#pug"
    ],
    "websiteUrl": "http://zbccostruzioni.it/"
  },
  "zgi": {
    "description": "Built an investment-focused corporate site presenting organizational information, members, and business offerings.",
    "tags": [
      "#css",
      "#sass",
      "#psdtohtml",
      "#javascript",
      "#jquery",
      "#debug",
      "#html",
      "#jade",
      "#pug",
      "#laravel"
    ],
    "websiteUrl": "http://zenogroupinvestments.com/home"
  },
  "vigattintourism": {
    "description": "Developed a tourism platform focused on destinations and travel discovery in the Philippines.",
    "tags": [
      "#codeigniter",
      "#psdtohtml",
      "#css",
      "#javascript",
      "#jquery",
      "#debug",
      "#test",
      "#enhancement",
      "#seo",
      "#mobileresponsive",
      "#less"
    ],
    "websiteUrl": "https://www.vigattintourism.com/"
  },
  "vigattindeals": {
    "description": "Delivered a deals and coupon platform featuring discount campaigns and commerce-focused user flows.",
    "tags": [
      "#codeigniter",
      "#psdtohtml",
      "#css",
      "#javascript",
      "#jquery",
      "#debug",
      "#test",
      "#paymentapi",
      "#enhancement",
      "#seo",
      "#mobileresponsive",
      "#less"
    ],
    "websiteUrl": "https://www.vigattindeals.com/"
  },
  "vigattintrade": {
    "description": "Built a buy-and-sell marketplace platform with listing and trading workflows similar to classified commerce models.",
    "tags": [
      "#codeigniter",
      "#psdtohtml",
      "#css",
      "#javascript",
      "#jquery",
      "#debug",
      "#test",
      "#enhancement",
      "#seo",
      "#mobileresponsive",
      "#less"
    ],
    "websiteUrl": "https://www.vigattintrade.com/"
  },
  "vigattin": {
    "description": "Implemented the primary Vigattin portal as the central entry point connecting the broader site ecosystem.",
    "tags": [
      "#codeigniter",
      "#psdtohtml",
      "#css",
      "#javascript",
      "#jquery",
      "#debug",
      "#test",
      "#enhancement",
      "#seo",
      "#mobileresponsive",
      "#less"
    ],
    "websiteUrl": "https://www.vigattin.com/"
  },
  "mb1": {
    "description": "Led front-end architecture for Metrobank AppKey, establishing a reusable module with Redux, unit tests, shared views, and composable subcomponents. The core design enabled lightweight integration across pages and modules while improving consistency and long-term maintainability.",
    "impact": "Adopted as the standard module pattern across Metrobank web properties, reducing new-feature integration time and improving cross-team consistency.",
    "tags": [
      "#reactJS",
      "#redux",
      "#frontend",
      "#unittesting",
      "#API",
      "#html",
      "#css"
    ],
    "gallery": [
      "/static/images/sites/mb2.png",
      "/static/images/sites/mb3.png"
    ]
  },
  "agent": {
    "description": "Spearheaded a full modernization of the GoAutoDial Agent Web Application — migrating a legacy jQuery/PHP monolith to a React/Laravel stack. Delivered a cleaner, fully responsive interface that made daily call-center workflows faster and more reliable.",
    "impact": "Legacy-to-modern migration reduced bug surface and improved agent productivity; WHMCS provisioning module automated cloud service setup for GoAutoDial customers.",
    "tags": [
      "#reactJS",
      "#laravel",
      "#php",
      "#legacymigration",
      "#ux",
      "#whmcs",
      "#responsive"
    ]
  },
  "tahanan": {
    "description": "Tahanan is a multi-tenant community platform I designed and built solo for homeowners associations and residential communities in the Philippines — live in production with real users, not a demo.\n\nI owned the product end-to-end without external funding. Deeper architecture and case-study detail are available on request for serious inquiries.",
    "impact": "Solo-shipped SaaS serving real communities in the Philippines — full product ownership from idea to production.",
    "tags": [
      "#laravel",
      "#nextjs",
      "#flutter",
      "#saas",
      "#multitenant",
      "#pwa",
      "#firebase",
      "#independentproject"
    ],
    "websiteUrl": "https://tahanan.org"
  },
  "ojp-workflow": {
    "description": "Personal dev tooling I built to streamline my own OnlineJobs.ph job search — search listings, generate tailored application packages, and track apply status in one place.\n\nIt's a private productivity project, not a public product. Happy to discuss the approach if you're interested.",
    "impact": "Automates search, CV tailoring, and application tracking for my remote job pipeline.",
    "tags": [
      "#python",
      "#fastapi",
      "#react",
      "#mcp",
      "#apify",
      "#automation",
      "#cursor",
      "#word",
      "#productivity"
    ]
  }
};

const PROJECT_ALIASES = {
  "stealth-saas": "tahanan",
};

export function getProjectDetails(projectId) {
  if (!projectId) return null;
  const resolved = PROJECT_ALIASES[projectId] || projectId;
  return PROJECT_DETAILS[resolved] || null;
}
